import * as e from "react";
const o = _ref => {
  let {
    shouldWarn: o,
    message: s
  } = _ref;
  e.useEffect(() => {
    o && ("undefined" == typeof process || process && "production" !== process.env.NODE_ENV) && console.warn(s);
  }, [o, s]);
};
export { o as useDeprecationWarning };